<template>
  <teleport to="body">
    <transition name="fade">
      <!-- popup background -->
      <div v-if="isVisible" class="bb-popup-bg d-flex justify-content-center align-items-center">
        <!-- popup box -->
        <div class="card bb-card bb-popup-card mb-2 rounded" :style="popupStyle">
          <slot></slot>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: "PopUpContents",

  props: {
    width: {
      type: String,
      default: '56rem',
    },
    height: {
      type: String,
      default: '62rem',
    },
  },

  data: () => ({
    isVisible: false,
  }),

  computed: {
    popupStyle() {
      return {
        width: `min(${this.width}, calc(100vw - 1rem))`,
        maxWidth: 'calc(100vw - 1rem)',
        height: `min(${this.height}, calc(100vh - 1rem))`,
        maxHeight: 'calc(100vh - 1rem)',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }
    },
  },

  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    },
  },
};
</script>